import React, {useEffect, useState} from "react";
import axios from "axios";

export default function () {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState([]);

  const getData = () => {
    axios.get("dashboard/sales-by-category").then(res => {
      if (res.data.status === 'success') {
        setData(res?.data);
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  useEffect(() => {
    getData()
  }, []);

  return (
    <div className="rounded bg-main-color px-5 mt-20">
      <div className="row">
        <div className="col-xl-12 mb-5 mb-xl-0">
          <div className="border-bottom">
            {/* shadow */}
            <div className="px-1 py-3 border-0">
              <div className="row align-items-center">
                <div>
                  <h3 className="mb-0 pt-3 text-muted ls-1 d-inline-block">
                    Orders By Categories
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mb-5">
          <div className="row">
            <table className="table align-middle table-row-dashed gy-5 no-footer">
              <thead className="color-dark-grey">
              <tr>
                <th className="p-0 py-5 pl-3">ID</th>
                <th className="p-0 py-5 pl-3">Name</th>
                <th className="p-0 py-5 pl-3">Orders Count</th>
              </tr>
              </thead>
              <tbody>
              {data?.sales_by_category?.map((item, key) => {
                  return (
                    <tr key={key} className="col-xxl-4 col-xl-6 p-10 mb-lg-0 mb-10">
                      <td
                        className="fs-6 text-muted pl-3"
                        title="id"
                      >
                        {item?.id}
                      </td>
                      <td
                        className="fs-6 text-muted"
                        title="name"
                      >
                        {item?.name}
                      </td>
                      <td
                        className="fs-6 text-muted"
                        title="orders count"
                      >
                        {item?.orders_count}
                      </td>
                    </tr>
                  )
                })
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}